import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { CommonService } from '../common/common.service';
import { UserDataService } from '../userData/user-data.service';

@Injectable({
  providedIn: 'root'
})
export class AdminRemarksService {

  constructor(public http: HttpClient, public userService: UserDataService) {}

  private extractData(res: Response) {
    let body = res;
    return body || { };
  }

  saveRemarks(token:any,adminRemark:any):Observable<any>{
    let url = CommonService.BASE_URL + '/api/v1/secure/forms/admin/remarks/save';
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + token
      })
    }
    return this.http.post(url,adminRemark,httpOptions)
    .pipe(
      map(this.extractData),
      catchError(error => {
        if (error.error instanceof ErrorEvent) {
          // A client-side or network error occurred. Handle it accordingly.
          console.error('An error occurred:', error.error.message);
        } else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong,
          console.error(
            `Backend returned code ${error.status}, ` +
            `body was: ${error.error}`);
          if (error.status === 403) {
            window.dispatchEvent(new CustomEvent('user:force-logout'));
          }
        }
        // return an observable with a user-facing error message
        return throwError(error);
      })
    );
  }

  getAdminRemark(token:any,formId:any): Observable<any> {
    let url = CommonService.BASE_URL + '/api/v1/secure/forms/admin/remarks/get/' + formId;
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + token
      })
    }
    return this.http.get(url, httpOptions)
      .pipe(
        map(this.extractData),
        catchError(error => {
          if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
          } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(
              `Backend returned code ${error.status}, ` +
              `body was: ${error.error}`);
            if (error.status === 403) {
              window.dispatchEvent(new CustomEvent('user:force-logout'));
            }
          }
          // return an observable with a user-facing error message
          return throwError(
            'Something bad happened; please try again later.');
        })
      );
  }

  resolveRemark(token:any,formId:any): Observable<any> {
    let url = CommonService.BASE_URL + '/api/v1/secure/forms/admin/remarks/resolve/' + formId;
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + token
      })
    }
    return this.http.get(url, httpOptions)
      .pipe(
        map(this.extractData),
        catchError(error => {
          if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
          } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(
              `Backend returned code ${error.status}, ` +
              `body was: ${error.error}`);
            if (error.status === 403) {
              window.dispatchEvent(new CustomEvent('user:force-logout'));
            }
          }
          // return an observable with a user-facing error message
          return throwError(
            'Something bad happened; please try again later.');
        })
      );
  }

  openRemark(token:any,formId:any): Observable<any> {
    let url = CommonService.BASE_URL + '/api/v1/secure/forms/admin/remarks/open/' + formId;
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + token
      })
    }
    return this.http.get(url, httpOptions)
      .pipe(
        map(this.extractData),
        catchError(error => {
          if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
          } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(
              `Backend returned code ${error.status}, ` +
              `body was: ${error.error}`);
            if (error.status === 403) {
              window.dispatchEvent(new CustomEvent('user:force-logout'));
            }
          }
          // return an observable with a user-facing error message
          return throwError(
            'Something bad happened; please try again later.');
        })
      );
  }

  deleteRemark(token:any,formId:any): Observable<any> {
    let url = CommonService.BASE_URL + '/api/v1/secure/forms/admin/remarks/delete/' + formId;
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + token
      })
    }
    return this.http.delete(url, httpOptions)
      .pipe(
        map(this.extractData),
        catchError(error => {
          if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
          } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(
              `Backend returned code ${error.status}, ` +
              `body was: ${error.error}`);
            if (error.status === 403) {
              window.dispatchEvent(new CustomEvent('user:force-logout'));
            }
          }
          // return an observable with a user-facing error message
          return throwError(
            'Something bad happened; please try again later.');
        })
      );
  }
  
}
